import { PaginationSize } from "@/common/enum/pagination-size";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { UserDto } from "@/types/dto/user-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";
import { Footer } from "./Footer";
import { Row } from "./Row";

interface Props {
  page: BasePageDto<UserDto>;
  handlePageChange: (currentPage: number) => void;
  openStatusModal: (user: UserDto) => void;
}

const headers = ["No", "관리자명", "부서", "연락처", "이메일", "권한"];

export const PlatformAdminTable: React.FC<Props> = ({
  page,
  openStatusModal,
  handlePageChange,
}) => {
  const datas = page.contents;
  const totalElements = page.totalElements;
  const currentPage = page.currentPage;
  const startIndex = totalElements - (currentPage - 1) * PaginationSize.SIZE_12;

  return (
    <div className="overflow-x-auto border rounded-lg">
      <Table className="">
        <Table.Head>
          {headers.map((title, index) => (
            <Table.HeadCell
              className={`${
                index === 0 ? "w-[56px]" : "w-[318.4px]"
              } h-[52px] p-0 border-b`}
              key={title}
            >
              <CustomCell
                className={`${
                  index === 5 ? "flex items-center justify-center" : ""
                }`}
              >
                <Footnote12Description className="text-semantic-text-secondary">
                  {title}
                </Footnote12Description>
              </CustomCell>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {datas.map((data, index) => (
            <Row
              key={data.id}
              data={data}
              index={index}
              startIndex={startIndex}
              openStatusModal={openStatusModal}
            />
          ))}
          <Footer
            headers={headers}
            page={page}
            handlePageChange={handlePageChange}
          />
        </Table.Body>
      </Table>
    </div>
  );
};
